// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"231":"70ca0fe751dc59ef9d59","589":"c4e08a21bdcdbad29f2a","610":"a5e38657d556ed721e59","678":"ab8d0a8675b6eda325b9","711":"612d5002ad87333d8d2f","883":"c4177ca993dd6967c9aa"}[chunkId] + ".js";
};